<template>
  <div class="common_search" :style="{ height: height + 'px' }">
    <div class="search">
      <input
        ref="input" v-model="val" class="input" maxlength="10"
        placeholder="搜索..." @click="showDrapdown" @keypress.enter="searchHandle(null, 1)">
      <em
        v-show="val.length" title="清空搜索内容" class="icon search_clear"
        @click="clearVal" />
      <em title="搜索" class="icon search_btn" @click="searchHandle(null, 1)" />
    </div>

    <!-- 下拉列表 -->
    <div v-show="recommendList.length && recommendVisible" class="recommend_box">
      <h4 class="title">热门搜索</h4>
      <ul>
        <li
          v-for="(item, index) in recommendList.slice(0, 6)" :key="index" class="recommend_item"
          @click="searchHandle(item, 0)">{{ item.value }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { homeListType } from '@/common/const.js'
import { report } from '@/report/index.js'

export default {
  name: 'Search',

  props: {
    recommendList: {
      type: Array,
      required: true
    },

    height: {
      type: Number,
      default: 55
    }
  },

  data () {
    return {
      val: '',
      recommendVisible: false,
    }
  },

  mounted () {
    document.addEventListener('click', this.settingHandle)
  },

  destroyed () {
    document.removeEventListener('click', this.settingHandle)
  },

  methods: {
    settingHandle (e) {
      if (!this.recommendVisible) { return }

      const className = e.target.className

      if (className.includes('input') || className.includes('recommend_item')) { return }

      this.recommendVisible = false
    },

    clearVal () { // 外部有调用
      this.val = ''
    },

    showDrapdown () {
      this.recommendVisible = true
    },

    searchHandle (item, pos) {
      report('mainclick', { area: 'search', pos })
      this.$store.commit('home/vuexChangeHomeListType', homeListType.search)

      const keyword = item?.value || this.val

      this.val = keyword
      this.$emit('search', keyword)

      this.recommendVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.common_search { position: relative; font-size: 16px; background-color: #fff;
  .search { position: relative; height: 100%;
    .input { width: 100%; height: 100%; padding: 0 0 0 15px; font-size: 16px; border: none; outline: none;
      &::-ms-clear { display: none; }
    }
    .icon { position: absolute; top: 13px; display: inline-block; width: 28px; height: 28px; cursor: pointer; background-repeat: no-repeat; background-position: center center; background-size: 28px 28px; border-radius: 4px;
      &.search_clear { right: 56px; background-image: url(~@/assets/images/icon_close.svg); }
      &.search_btn { right: 12px; background-image: url(~@/assets/images/icon_search.svg); }
      &:hover { background-color: #f3f3f6; }
    }
  }
  .recommend_box { position: absolute; z-index: 2; box-sizing: border-box; width: 100%; min-height: 100px; padding: 13px 0 13px 15px; background-color: #fff; box-shadow: $box_shadow_3;
    .title { font-weight: 400; color: $font_color_8; }
    .recommend_item { box-sizing: border-box; display: inline-block; min-width: 53px; height: 27px; padding: 0 10px; margin: 14px 17px 0 0; font-weight: 400; line-height: 25px; color: $font_color_6; text-align: center; cursor: pointer; border: 1px solid $font_color_2; border-radius: 4px;
      &:hover { background-color: rgba(171, 173, 188, 0.2); }
    }
  }
}

</style>
